import { PageContainer } from '@components';
import { Certification } from '@views/Certification';
import { useParams } from 'react-router';
import { useEffect } from 'react';
import { store } from '@store';

const allCertificationsParams = { index: 0, entriesPerPage: 0, model: {} };

const CertificationPage = () => {
  const { id } = useParams();

  const questionsRespondentFiltered = store.use.questionsRespondentFiltered();
  const getQuestionsRespondentAction = store.use.getQuestionsRespondentAction().call;
  const isLoadingGetQuestionsRespondentAction =
    store.use.getQuestionsRespondentAction().status === 'LOADING';

  const certification = store.use
    .certificationsFiltered()
    .find((certification) => certification.idCertificationUserTest === id);
  const getCertificationsAction = store.use.getCertificationsAction().call;

  useEffect(() => {
    getQuestionsRespondentAction({
      model: { idCertificationUserTest: id },
    });
    if (!certification) {
      getCertificationsAction(allCertificationsParams);
    }
  }, [id]);

  return (
    <PageContainer>
      <Certification
        certification={certification}
        questionsRespondentFiltered={questionsRespondentFiltered}
        isLoading={isLoadingGetQuestionsRespondentAction}
      />
    </PageContainer>
  );
};
export default CertificationPage;
